import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, Cylinder, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 5,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [3, 0.4, 3], mass: 4, position: [0, 0.2, 0], type: 'Box' },
      { args: [1.6, 0.2, 0.6], mass: 1, position: [0, 0.45, 1.2], type: 'Box' }
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 0.2, 0]} args={[3, 0.4, 3]} />
      <Box position={[0, 0.45, 1.2]} args={[1.6, 0.2, 0.6]} color="#2a2a2a" />

      <Cylinder position={[1.2, 0, 1.2]} args={[0.1, 0.1, 0.1, 8]} color="#2a2a2a" />
      <Cylinder position={[-1.2, 0, 1.2]} args={[0.1, 0.1, 0.1, 8]} color="#2a2a2a" />
      <Cylinder position={[1.2, 0, -1.2]} args={[0.1, 0.1, 0.1, 8]} color="#2a2a2a" />
      <Cylinder position={[-1.2, 0, -1.2]} args={[0.1, 0.1, 0.1, 8]} color="#2a2a2a" />
    </group>
  );
};
